{
  "intro": "Частные сети соединяют ваши серверы друг с другом в обход интернета. Трафик внутри сети бесплатный и не входит в трафик серверов. Сеть работает в одной сетевой зоне; подключить к ней можно серверы этой зоны.",
  "create": "Создать сеть",
  "createLead": "Сети нужен частный диапазон адресов и хотя бы одна подсеть в зоне, где стоят ваши серверы.",
  "empty": "Частных сетей пока нет",
  "emptyLead": "Объедините в сеть серверы, которые работают вместе, например приложение и его базу данных: они будут обращаться друг к другу по внутренним адресам, базе не понадобится открытый порт, а трафик ничего не стоит.",
  "name": "Название",
  "nameHint": "Для чего сеть, например backend.",
  "ipRange": "Диапазон адресов",
  "ipRangeHint": "Частный диапазон, от /8 до /24. В 10.0.0.0/16 поместится 256 подсетей.",
  "ipRangeWhy": "Подходят только частные диапазоны (10.0.0.0/8, 172.16.0.0/12, 192.168.0.0/16). Выберите такой, который не пересекается с сетями, куда вы подключаетесь, например с офисным VPN.",
  "zone": "Сетевая зона",
  "zoneHint": "К первой подсети смогут подключиться серверы этой зоны.",
  "zoneWhy": "Сетевая зона — группа близких площадок; например, eu-central включает Фалькенштайн, Нюрнберг и Хельсинки. Подсеть работает только в одной зоне.",
  "subnet": "Первая подсеть",
  "subnetHint": "Часть диапазона, из которой серверы получают адреса. В /24 поместится 253 сервера.",
  "submit": "Создать сеть",
  "created": "Сеть «{{name}}» создана",
  "rangeInvalid": "Укажите диапазон вида 10.0.0.0/16, начиная с первого адреса блока.",
  "rangeNotPrivate": "Нужен частный диапазон (10.x, 172.16–31.x или 192.168.x) от /8 до /24.",
  "subnetInvalid": "Укажите подсеть вида 10.0.0.0/24.",
  "subnetOutside": "Подсеть должна лежать внутри диапазона сети.",
  "subnets": "Подсети",
  "servers": "Серверы",
  "createdOn": "Создана",
  "open": "Открыть",
  "delete": "Удалить",
  "protected": "Защита от удаления",
  "protectedReason": "Включена защита от удаления; сначала отключите её в настройках.",
  "notFound": "Этой сети больше нет.",
  "back": "Все сети",
  "tabs": {
    "resources": "Ресурсы",
    "subnets": "Подсети",
    "routes": "Маршруты",
    "settings": "Настройки",
    "delete": "Удаление"
  },
  "resourcesIntro": "Серверы в этой сети и их внутренние адреса. Сервер можно подключить, если в сети есть подсеть в его зоне.",
  "attach": "Подключить сервер",
  "attachLead": "Сервер получит адрес в подсети своей зоны и новый сетевой интерфейс. Большинство образов поднимают его сами; в остальных настройте его в системе.",
  "attachServer": "Сервер",
  "attachNone": "Подключить нечего: все серверы проекта уже в сети или ни один не стоит в зоне её подсетей.",
  "attachIp": "Фиксированный адрес (необязательно)",
  "attachIpHint": "Оставьте пустым, и провайдер выдаст следующий свободный адрес.",
  "attachSubmit": "Подключить",
  "attached": "Подключаем «{{name}}» к сети",
  "noServers": "В сети пока нет серверов",
  "noServersLead": "Подключите сервер, чтобы он получил внутренний адрес в этой сети.",
  "privateIp": "Внутренний адрес",
  "detach": "Отключить",
  "detachTitle": "Отключить «{{name}}» от сети?",
  "detachConsequence": "Сервер потеряет внутренний адрес {{ip}}: другие серверы больше не смогут обращаться к нему через эту сеть.",
  "detachPublic": "Публичные адреса сервера не меняются.",
  "detached": "Отключаем «{{name}}»",
  "subnetsIntro": "Подсети делят диапазон сети. Серверы получают адреса из подсети своей зоны; первый адрес каждой подсети занят её маршрутизатором.",
  "addSubnet": "Добавить подсеть",
  "addSubnetLead": "Подсеть должна лежать внутри {{range}} и не пересекаться с другими подсетями.",
  "subnetRange": "Диапазон подсети",
  "subnetRangeHint": "Например, 10.0.1.0/24.",
  "subnetOverlaps": "Этот диапазон пересекается с уже существующей подсетью.",
  "subnetZone": "Сетевая зона",
  "subnetType": "Тип",
  "subnetTypes": {
    "cloud": "Облачные серверы",
    "server": "Выделенные серверы",
    "vswitch": "vSwitch"
  },
  "gateway": "Маршрутизатор",
  "subnetAdded": "Добавляем подсеть {{range}}",
  "deleteSubnet": "Удалить подсеть",
  "deleteSubnetTitle": "Удалить подсеть {{range}}?",
  "deleteSubnetConsequence": "Серверы зоны {{zone}} больше не смогут подключаться через эту подсеть.",
  "deleteSubnetInUse": "Серверы, у которых ещё есть адреса в ней, нужно сначала отключить.",
  "subnetDeleted": "Удаляем подсеть {{range}}",
  "subnetBusy": "В этой подсети есть адреса серверов; сначала отключите их.",
  "routesIntro": "Маршруты направляют трафик к другим диапазонам через один из ваших серверов, например через сервер с VPN или NAT. Шлюз — внутренний адрес такого сервера.",
  "addRoute": "Добавить маршрут",
  "addRouteLead": "Трафик к назначению пойдёт на шлюз; шлюз должен быть адресом внутри {{range}}.",
  "destination": "Назначение",
  "destinationHint": "Диапазон, который нужно направить, например 10.100.0.0/16, или 0.0.0.0/0 — весь трафик, уходящий из сети.",
  "routeGateway": "Шлюз",
  "routeGatewayHint": "Внутренний адрес сервера, который пересылает трафик.",
  "gatewayInvalid": "Укажите адрес внутри сети, например 10.0.0.2.",
  "routeAdded": "Добавляем маршрут к {{destination}}",
  "noRoutes": "Маршрутов нет",
  "noRoutesLead": "Без маршрутов серверы по внутренним адресам видят только эту сеть. Добавьте маршрут, если один сервер пересылает трафик для других.",
  "deleteRoute": "Удалить маршрут",
  "deleteRouteTitle": "Удалить маршрут к {{destination}}?",
  "deleteRouteConsequence": "Трафик к {{destination}} больше не будет идти через {{gateway}}.",
  "routeDeleted": "Удаляем маршрут к {{destination}}",
  "settingsIntro": "Название, метки и защита сети.",
  "rename": "Название",
  "saved": "Сохранено",
  "labels": "Метки",
  "labelsHint": "По одной на строку в виде ключ=значение, например env=production. Метки помогают находить и группировать ресурсы.",
  "labelsInvalid": "Строка {{line}} — не метка: нужно ключ=значение, латинские буквы, цифры, точка, дефис или подчёркивание, до 63 символов каждое.",
  "protection": "Защита от удаления",
  "protectionOn": "Защита от удаления включена: сеть нельзя удалить ни намеренно, ни по ошибке, пока вы её не отключите.",
  "protectionOff": "Защита от удаления выключена: любой с правом записи может удалить сеть.",
  "protectionEnable": "Включить защиту от удаления",
  "protectionDisable": "Отключить защиту от удаления",
  "protectionChanging": "Меняем защиту",
  "deleteIntro": "Удаление сети нельзя отменить.",
  "deleteTitle": "Удалить сеть «{{name}}»?",
  "deleteServers": "Подключённые серверы ({{count}}) потеряют внутренний адрес в этой сети и не смогут обращаться друг к другу через неё.",
  "deleteSubnetsRoutes": "Подсети и маршруты удаляются вместе с сетью.",
  "deletePublic": "Публичные адреса и данные серверов сохранятся.",
  "deleteBlocked": "Включена защита от удаления. Сначала отключите её в настройках.",
  "toSettings": "Перейти в настройки",
  "deleted": "Сеть «{{name}}» удалена",
  "running": "Изменение выполняется…"
}
